export default __webpack_public_path__ + "static/media/PI.013d1e3d.jfif";